import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { FormDataService } from '../data.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { EmailService } from '../../../email/services/email.service';
import { ProjectDataService } from '../../../project/services/project-data.service';
import { ProjectDetailService } from '../../../project/services/project-shared.service';
import { CastProject } from '../../../project/project.functions';
import { formStatus } from '../../form.constants';
import { projectStatus } from '../../../project/project.constants';
import { StatusLog } from '../../../project/models/status-log.model';
import { UserContextService } from '../../../user/services/user-context.service';


@Injectable()
export class SendRdApprovalLetterActionHandlerService extends FormActionHandlerService {
  constructor(
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private dataService: FormDataService,
    private swal: SwalService,
    private emailService: EmailService,
    private projectDataService: ProjectDataService,
    private projectDetailService: ProjectDetailService,
    private userContext: UserContextService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise(resolve => {
      that.swal
        .yesOrNo({
          title: 'Send Approval Letter?',
          text:
            'This will complete the review and email the approval letter to the applicant.'
        })
        .then(() => {
          that.swal.load('Sending Approval Letter...', 'Please wait.');

          that.statusService.changeStatus(formStatus.reviewComplete);

          that.shareService.project.projectStatusLog.unshift(<StatusLog>{
            creator: that.userContext.currentUser.id,
            status: projectStatus.projectActive,
            statusDate: new Date()
          });

          that.dataService.saveForm().subscribe(
            () => {
              const projectId =
                that.shareService.projectBase.projectInfo.projectId;
              that.emailService.sendRdApprovalLetter(projectId).subscribe(
                () => {
                  that.swal
                    .success({
                      title: 'Success!',
                      text: 'The approval letter has been sent to the applicant.'
                    })
                    .then(() => that.pullProject().then(() => resolve()))
                    .catch(() => that.pullProject().then(() => resolve()));
                },
                () => {
                  that.swal
                    .error({
                      title: 'Oops!',
                      text:
                        'The review was marked complete, but an error occurred while sending the approval letter.'
                    })
                    .then(() => that.pullProject().then(() => resolve()))
                    .catch(() => that.pullProject().then(() => resolve()));
                }
              );
            },
            () => {
              that.swal
                .error({
                  title: 'Oops!',
                  text:
                    'We were unable to update the form status. Please try again later.'
                })
                .then(() => resolve())
                .catch(() => resolve());
            }
          );
        })
        .catch(() => resolve());
    });
  }

  private pullProject(): Promise<void> {
    const projectGuid = this.shareService.formId.projectGuid;
    return new Promise(resolve => {
      this.projectDataService.getProject(projectGuid).subscribe(
        project => {
          if (project) {
            this.projectDetailService.project = CastProject(
              project,
              project.projectInfo.incentiveProgram
            );
          }
          resolve();
        },
        () => resolve()
      );
    });
  }
}
